// src/App.js
import { Routes, Route, Link } from 'react-router-dom';
import LandingPage from './LandingPage/landing';
import LoginForm from './Login/login';
import RunningElections from './ElectionList/electionList';
import Leaderboard from './LeaderBoard/leaderboard';
import Guidelines from './Guidelines/guidelines';


export default function App() {
  return (
    <>

      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/leaderboard" element={<Leaderboard />} />

        <Route path="/login" element={<LoginForm />} />
        <Route path='/running' element={<RunningElections />} />
        <Route path="/guidelines" element={<Guidelines />} />
        {/* or <Route path="*" element={<Login />} /> if you want every URL to show Login */}
      </Routes>
    </>
  );
}
